(function () {
  var MQ_MOBILE = window.matchMedia('(max-width: 749px)');

  function isMobile() {
    return MQ_MOBILE.matches;
  }

  function isContactHost() {
    return window.ciwLaHostApi ? window.ciwLaHostApi.isContactLens() : !!document.querySelector('.cl-section');
  }

  function getTitles() {
    var config = window.ciwLaStepTitles || {};
    return {
      contactLens: config.contactLens || 'Fill prescription manually',
      manualEntry: config.manualEntry || 'Enter your prescription manually',
      upload: config.upload || 'Upload your prescription',
      review: config.review || 'Review your order'
    };
  }

  function setStepTitle(title) {
    if (!title) return;

    var titleEl =
      document.querySelector('#la_prescriptionSelect_title') ||
      document.querySelector('.la-prescription-modal-content-body .la-wrapper-heading h3');

    if (!titleEl || titleEl.textContent.trim() === title) return;
    titleEl.textContent = title;
  }

  function updateContactStepTitles() {
    if (!isContactHost() || !isMobile() || !document.body.classList.contains('la-modal-open')) {
      return;
    }

    var titles = getTitles();

    if (document.querySelector('.la-choose-prescription-wrapper.la-render-review')) {
      setStepTitle(titles.review);
      return;
    }

    var rxForm = document.querySelector('#la-prescription-form');

    if (
      rxForm &&
      (rxForm.querySelector('.ciw-la-contact-rx-card') ||
        rxForm.querySelector('.la-prescription-fields-wrapper .la-form-item[key]') ||
        rxForm.querySelector('.la-right-rx-container'))
    ) {
      if (rxForm.querySelector('.ciw-la-manual-rx-heading')) {
        return;
      }
      setStepTitle(titles.contactLens);
      return;
    }

    if (rxForm && rxForm.querySelector('.la-upload-wrapper')) {
      setStepTitle(titles.upload);
      return;
    }

    if (document.querySelector('.la-quantity-selector-wrapper')) {
      setStepTitle(titles.contactLens);
    }
  }

  function scheduleContactStepTitles() {
    updateContactStepTitles();
    window.setTimeout(updateContactStepTitles, 0);
    window.setTimeout(updateContactStepTitles, 150);
    window.setTimeout(updateContactStepTitles, 400);
  }

  function bind() {
    if (!isContactHost()) return;

    var events = [
      'LensAdvizor:component:DidMount',
      'LensAdvizor:selectLensModal:open',
      'LensAdvizor:review:rendered',
      'LensAdvizor:render:submissionMethods',
      'LensAdvizor:render:manualEntryForm',
      'LensAdvizor:render:contactLensForm'
    ];

    events.forEach(function (eventName) {
      document.addEventListener(eventName, scheduleContactStepTitles);
    });

    if (typeof MQ_MOBILE.addEventListener === 'function') {
      MQ_MOBILE.addEventListener('change', scheduleContactStepTitles);
    } else if (typeof MQ_MOBILE.addListener === 'function') {
      MQ_MOBILE.addListener(scheduleContactStepTitles);
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('.cl-la-trigger, lensadvizor-btn, .cl-la-slot lensadvizor-btn')) {
        window.setTimeout(scheduleContactStepTitles, 300);
        window.setTimeout(scheduleContactStepTitles, 800);
      }
    });

    scheduleContactStepTitles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
